import {utils} from '@wallaby-ui/core';
import {get} from 'lodash';

export const CELL_RENDERER_PARAMS_AG = 'cellRendererParams';
export const CELL_RENDERER_PARAMS = 'formatterParams';

export const CELL_RENDERER_PARAMS_HEIGHT_BY_CONTENT = 'heightByContent';
const CELL_RENDERER_PARAMS_VALUE_PATH = 'valuePath';
const CELL_RENDERER_PARAMS_VALUE_MARGIN = 'valueMargin';
const CELL_RENDERER_PARAMS_PARSE = 'parse';
const CELL_RENDERER_PARAMS_PARSED_PATH = 'parsedPath';
const CELL_RENDERER_PARAMS_ITEM_PATH = 'itemPath';
const CELL_RENDERER_PARAMS_ITEM_MARGIN = 'itemMargin';
const CELL_RENDERER_PARAMS_FONT = 'font';
const CELL_RENDERER_PARAMS_MEASUREMENT_ERROR = 'measurementError';
const CELL_RENDERER_PARAMS_LABEL_COLUMN = 'labelColumn';
const CELL_RENDERER_PARAMS_LINK_COLUMN = 'linkColumn';
const CELL_RENDERER_PARAMS_REUSE_FILTER = 'reuseFilter';
const CELL_RENDERER_PARAMS_LOCATION_PATH = 'locationPath';
const CELL_RENDERER_PARAMS_ROUTE = 'route';
const CELL_RENDERER_PARAMS_FILTER_NAME = 'filterName';
const CELL_RENDERER_PARAMS_I18N_PARAMS = 'i18nParams';
const CELL_RENDERER_PARAMS_ICON = 'icon';
const CELL_RENDERER_PARAMS_FORMAT = 'format';
const CELL_RENDERER_PARAMS_COLOR = 'color';
const CELL_RENDERER_PARAMS_FONT_FAMILY = 'fontFamily';
const CELL_RENDERER_PARAMS_CHART_TYPE = 'chartType';

export class CellRendererParams {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  getCellValue(value, translateService) {
    let ownValue = value;

    // value is an object, get the ownValue
    if (this.getValuePath()) {
      ownValue = get(ownValue, this.getValuePath());
    }
    // value is a stringified JSON object, parse the ownValue
    if (this.getParse()) {
      ownValue = JSON.parse(ownValue);
      // parsed value is an object, get the ownValue
      if (this.getParsedPath()) {
        ownValue = get(ownValue, this.getParsedPath());
      }
    }

    return utils.TranslateUtils.translate(ownValue, translateService);
  }

  getCellItemValue(cellValue, translateService) {
    let ownValue = cellValue;

    if (this.getItemPath()) {
      ownValue = get(ownValue, this.getItemPath());
    }

    return utils.TranslateUtils.translate(ownValue, translateService);
  }

  getRawData() {
    return this.rawData;
  }

  getHeightByContent() {
    return this.rawData[CELL_RENDERER_PARAMS_HEIGHT_BY_CONTENT];
  }

  getValuePath() {
    return this.rawData[CELL_RENDERER_PARAMS_VALUE_PATH];
  }

  getValueMargin() {
    return this.rawData[CELL_RENDERER_PARAMS_VALUE_MARGIN];
  }

  getParse() {
    return this.rawData[CELL_RENDERER_PARAMS_PARSE];
  }

  getParsedPath() {
    return this.rawData[CELL_RENDERER_PARAMS_PARSED_PATH];
  }

  getItemPath() {
    return this.rawData[CELL_RENDERER_PARAMS_ITEM_PATH];
  }

  getItemMargin() {
    return this.rawData[CELL_RENDERER_PARAMS_ITEM_MARGIN];
  }

  getFont() {
    return this.rawData[CELL_RENDERER_PARAMS_FONT];
  }

  getFontFamily() {
    return this.rawData[CELL_RENDERER_PARAMS_FONT_FAMILY];
  }

  getMeasurementError() {
    return this.rawData[CELL_RENDERER_PARAMS_MEASUREMENT_ERROR];
  }

  getLabelColumn() {
    return this.rawData[CELL_RENDERER_PARAMS_LABEL_COLUMN];
  }

  getLinkColumn() {
    return this.rawData[CELL_RENDERER_PARAMS_LINK_COLUMN];
  }

  getReuseFilter() {
    return this.rawData[CELL_RENDERER_PARAMS_REUSE_FILTER];
  }

  getLocationPath() {
    return this.rawData[CELL_RENDERER_PARAMS_LOCATION_PATH];
  }

  getRoute() {
    return this.rawData[CELL_RENDERER_PARAMS_ROUTE];
  }

  getFilterName() {
    return this.rawData[CELL_RENDERER_PARAMS_FILTER_NAME];
  }

  getI18nParams() {
    return this.rawData[CELL_RENDERER_PARAMS_I18N_PARAMS];
  }

  getIcon() {
    return this.rawData[CELL_RENDERER_PARAMS_ICON];
  }

  getFormat() {
    return this.rawData[CELL_RENDERER_PARAMS_FORMAT];
  }

  getColor() {
    return this.rawData[CELL_RENDERER_PARAMS_COLOR];
  }

  getChartType() {
    return this.rawData[CELL_RENDERER_PARAMS_CHART_TYPE];
  }
}

export default {CellRendererParams};
